import React from 'react';
import { IPreloadCacheContext } from 'framework/context/IPreloadCacheContext';
import { INotificationWithStatusDto } from 'gen/ApiClient';

export const CacheContext = React.createContext<IPreloadCacheContext<INotificationWithStatusDto[]>>(undefined as any);
